export default "__VITE_ASSET__a566ec1b__"